<template>
  <div class="print-labe-Container" style="width: 100%; height: 100%">
    <div style="height: 45px">
      <router-link
        :to="{
          path: '/DischargePermissions/DischargeCheckOut/' + dataFromParent.id,
          query: {
            storeId: dataFromParent.storeId,
            isProcess: dataFromParent.isProcess,
          },
        }"
      >
        <vs-button
          icon-pack="feather"
          class="hide-in-print float-right"
          style="background-color: #444"
          type="filled"
        >
          {{ $t("Back") }}
        </vs-button>
      </router-link>
    </div>
    <div
      v-if="!isDisplayWithQrcode"
      id="smalllabelPrint"
      class="card pt-0 mb-2 mt-0 flex"
      v-for="(lebel, index) in allDataForShow"
      :key="index"
    >
      <div class="flex w-full pt-5 pl-10">
        <div class="w-2/3">
          <div class="vx-row" style="height: 1.75cm">
            <div class="vx-col w-6/12 p-0" style="height: 100%">
              <h3 v-if="lebel.identificationCode" style="text-align: center">
                {{ $t("IdentificationCode") }}
              </h3>
              <barcode
                v-if="lebel.identificationCode"
                style="height: 40% !important; width: 70% !important"
                :value="lebel.identificationCode"
                :options="{ displayValue: false }"
              ></barcode>
              <h3
                :class="lebel.identificationCode ? '' : 'mt-8'"
                class="m-0"
                style="text-align: center; font-weight: bold"
              >
                {{
                  lebel.identificationCode
                    ? lebel.identificationCode
                    : $t("WithoutIdentificationCode")
                }}
              </h3>
            </div>
            <div
              class="vx-col w-6/12 p-0"
              style="border-right: 1px solid black; height: 100%"
            >
              <h3 v-if="lebel.trackingId" style="text-align: center">
                {{ $t("TrackingId") }}
              </h3>
              <barcode
                v-if="lebel.trackingId"
                style="height: 40% !important; width: 70% !important"
                :value="lebel.trackingId"
                :options="{ displayValue: false }"
              ></barcode>
              <h3
                :class="lebel.trackingId ? '' : 'mt-8'"
                class="m-0"
                style="text-align: center; font-weight: bold"
              >
                {{
                  lebel.trackingId ? lebel.trackingId : $t("WithoutTrackingId")
                }}
              </h3>
            </div>
          </div>
          <hr />
          <div class="vx-row ml-3" style="height: 1.8cm">
            <span class="vx-col w-full p-0" style="height: 100%">
              <h3 class="m-0" style="text-align: center">{{ $t("Serial") }}</h3>
              <h3 class="m-0" style="text-align: center">
                {{ allDataForShow[index].rowId }}
              </h3>
              <barcode
                style="height: 40% !important; width: 80% !important"
                :value="lebel.serial"
                :options="{ displayValue: false }"
              ></barcode>
              <h3 class="m-0" style="text-align: center">
                {{ lebel.serial }}
              </h3>
            </span>
          </div>
        </div>
        <div class="w-1/3 pl-2 pt-2">
          <qrcode-vue
            :value="lebel.qrCodeInfo"
            :size="size"
            :class="'qr-canvas'"
            level="L"
          ></qrcode-vue>
        </div>
      </div>
    </div>
    <div
      v-if="isDisplayWithQrcode"
      id="labelPrint"
      class="card pt-0 mb-2 mt-0"
      v-for="(lebel, index) in allDataForShow"
      :key="index"
    >
      <div style="display: flex; width: 100%; padding: 15px 15px 2px 15px; gap: 10px">
        <div
          class="vx-row"
          style="display: flex; flex-direction: column; flex: 1"
        >
          <div style="display: flex; width: 100%">
            <div class="vx-col w-6/12 p-0">
              <h3 v-if="lebel.identificationCode" style="text-align: center">
                {{ $t("IdentificationCode") }}
              </h3>
              <barcode
                v-if="lebel.identificationCode"
                style="height: 40% !important; width: 70% !important"
                :value="lebel.identificationCode"
                :options="{ displayValue: false }"
              ></barcode>
              <h3
                :class="lebel.identificationCode ? '' : 'mt-8'"
                class="m-0"
                style="text-align: center; font-weight: bold"
              >
                {{
                  lebel.identificationCode
                    ? lebel.identificationCode
                    : $t("WithoutIdentificationCode")
                }}
              </h3>
            </div>
            <div
              class="vx-col w-6/12 p-0"
              style="border-right: 1px solid black"
            >
              <h3
                v-if="lebel.trackingId"
                style="text-align: center; font-weight: bold"
              >
                {{ $t("TrackingId") }}
              </h3>
              <barcode
                v-if="lebel.trackingId"
                style="height: 40% !important; width: 70% !important"
                :value="lebel.trackingId"
                :options="{ displayValue: false }"
              ></barcode>
              <h3
                :class="lebel.trackingId ? '' : 'mt-8'"
                class="m-0"
                style="text-align: center; font-weight: bold"
              >
                {{
                  lebel.trackingId ? lebel.trackingId : $t("WithoutTrackingId")
                }}
              </h3>
            </div>
          </div>
          <div class="vx-row ml-3" style="height: 1.8cm">
            <span class="vx-col w-full p-0" style="height: 100%">
              <h3 class="m-0" style="text-align: center; font-weight: bold">
                {{ $t("Serial") }}
              </h3>
              <h3 class="m-0" style="text-align: center; font-weight: bold">
                {{ allDataForShow[index].rowId }}
              </h3>
              <barcode
                style="height: 40% !important; width: 80% !important"
                :value="lebel.serial"
                :options="{ displayValue: false }"
              ></barcode>
              <h3 class="m-0" style="text-align: center">
                {{ lebel.serial }}
              </h3>
            </span>
          </div>
        </div>
        <hr />
        <div class="qrcode-box" style="width: 40%">
          <qrcode-vue
            :value="lebel.qrCodeInfo"
            :size="size"
            :class="'qr-canvas'"
            level="L"
          ></qrcode-vue>
        </div>
      </div>
      <div class="garanti-info">
        <p>
          جهت کسب اطلاعات بیشتر در خصوص شرایط گارانتی و مراکز خدمات به وب سایت
          آواژنگ مراجعه نمایید
        </p>
        <span>avajang.com</span>
      </div>
    </div>

    <div v-if="allDataForShow.length > 0" class="vx-row">
      <div class="w-full vx-col">
        <vs-button
          type="button"
          class="float-right purple hide-in-print"
          @click="printWindow()"
          >{{ $t("Print") }}</vs-button
        >
        <vs-button
          type="button"
          class="float-right purple hide-in-print ml-3"
          @click="displayMode()"
        >
          {{ toggleDisplayModeName }}</vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import VueBarcode from "@xkeshi/vue-barcode";
import { QRCanvas } from "qrcanvas-vue";
import "@/assets/scss/vuesax-rtl/_label.scss";
import QrcodeVue from "qrcode.vue";

export default {
  name: "warehouseManagement_DischargePermission_Index",
  data() {
    return {
      allDataForShow: {},
      model: {},
      modelForApi: {},
      dataFromParent: this.$route.query,
      dataFromLocalStorage: [],
      listSerialsUnseen: [],
      isDisplayWithQrcode: false,
      toggleDisplayModeName: "نمایش حالت جدید",
      options: {
        cellSize: 8,
        correctLevel: "H",
        data: "",
      },
      size: 120,
    };
  },
  computed: {
    ...mapGetters({
      recipientInfoDetails: "draftOrder/recipientInfoDetails",
    }),
  },

  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      ReadInfoForWarrantyCard: "checkOutTransactions/ReadInfoForLabelCard",
    }),
    countNewSerials() {
      this.dataFromLocalStorage = JSON.parse(
        localStorage.getItem(
          "basket" +
            this.dataFromParent.basketId +
            "store" +
            this.dataFromParent.storeId
        )
      );
      for (let index = 0; index < this.dataFromLocalStorage.length; index++) {
        if (
          this.dataFromParent.itemCode ==
          this.dataFromLocalStorage[index].itemCode
        ) {
          for (
            let ii = 0;
            ii < this.dataFromLocalStorage[index].serialsInfo.length;
            ii++
          ) {
            if (
              !this.dataFromLocalStorage[index].serialsInfo[ii].isshowLabelPrint
            ) {
              var serialData = {
                serial: this.dataFromLocalStorage[index].serialsInfo[ii].serial,
                index: this.dataFromLocalStorage[index].serialsInfo[ii].index,
              };
              this.listSerialsUnseen.push(serialData);
            }
          }
          break;
        }
      }
    },
    async load() {
      this.notAddNewSerials = false;
      this.modelForApi = {};
      await this.countNewSerials();
      if (this.listSerialsUnseen.length) {
        await this.$swal({
          title:
            "تعداد " +
            this.listSerialsUnseen.length +
            " سریال جدید چاپ شود یا تمام سریال ها ؟",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "فقط سریال های جدید",
          cancelButtonText: "تمام سریال ها",
        }).then((result) => {
          if (result.value) {
            this.onlyShowNewSerilas();
          } else {
            this.withoutNewSerilas();
          }
        });
      } else {
        this.withoutNewSerilas();
      }
      this.updateValueIsShowLabelPrint();
    },
    updateValueIsShowLabelPrint() {
      for (let index = 0; index < this.dataFromLocalStorage.length; index++) {
        if (
          this.dataFromParent.itemCode ==
          this.dataFromLocalStorage[index].itemCode
        ) {
          for (
            let ii = 0;
            ii < this.dataFromLocalStorage[index].serialsInfo.length;
            ii++
          ) {
            this.dataFromLocalStorage[index].serialsInfo[
              ii
            ].isshowLabelPrint = true;
          }
          break;
        }
      }
      localStorage.removeItem("basket" + this.dataFromParent.basketId);
      localStorage.setItem(
        "basket" + this.dataFromParent.basketId,
        JSON.stringify(this.dataFromLocalStorage)
      );
    },
    withoutNewSerilas() {
      this.modelForApi = {
        stockId: this.dataFromParent.productId,
        sortSerialsDto: this.dataFromParent.sortSerialsDto,
      };
      this.ReadInfoForWarrantyCard(this.modelForApi).then((r) => {
        this.allDataForShow = r;
        this.options.data = r[0].qrCodeInfo;
      });
    },
    onlyShowNewSerilas() {
      this.modelForApi = {
        stockId: this.dataFromParent.productId,
        sortSerialsDto: this.listSerialsUnseen,
      };
      this.ReadInfoForWarrantyCard(this.modelForApi).then((r) => {
        this.allDataForShow = r;
        this.options.data = r[0].qrCodeInfo;
      });
    },
    printWindow() {
      window.print();
      this.$router.push({
        path:
          "/DischargePermissions/DischargeCheckOut/" + this.dataFromParent.id,
        query: {
          storeId: this.dataFromParent.storeId,
          isProcess: this.dataFromParent.isProcess,
        },
      });
    },
    displayMode() {
      if (this.isDisplayWithQrcode) {
        this.isDisplayWithQrcode = false;
        this.toggleDisplayModeName = "نمایش حالت جدید";
      } else {
        this.isDisplayWithQrcode = true;
        this.toggleDisplayModeName = "نمایش حالت قدیم";
      }
    },
  },
  components: {
    QRCanvas,
    VueBarcode,
    QrcodeVue,
  },
};
</script>
<style scoped>
.qrcode-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
}
.garanti-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  p {
    font-size: 10px;
    color: black !important;
    text-align: center;
    font-family: "IRANSans", "IRANSans-Standard";
    font-weight: bold;
  }
  span {
    font-size: 11px;
    text-align: center;
    color: black !important;
    font-family: "IRANSans", "IRANSans-Standard";
    font-weight: bold;
  }
}
</style>
